import Flex from '@decisiv/ui-components/lib/components/Flex';
import styled from 'styled-components';

export const FormContainer = styled(Flex).attrs({ flex: 1 })`
  display: flex;
  flex-direction: column;
  gap: 10px;

  & > div {
    margin-right: 0;
    margin-left: 0;
  }
`;
